import { Divider, Tooltip } from "antd";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { BsCalendar2CheckFill, BsCalendar2Minus } from "react-icons/bs";
import { FaFile, FaRegFile } from "react-icons/fa";
import {
  IoChatbubbleEllipsesOutline,
  IoChatbubbleEllipsesSharp,
  IoSettingsOutline,
  IoSettingsSharp,
} from "react-icons/io5";
import {
  RiOrganizationChart,
  RiRecordCircleFill,
  RiRecordCircleLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import apiFactory from "../../api";
import { sideBarFeatureEvent$ } from "../../api/eventBus";
import { closeAuthSocket, closeChatSocket } from "../../api/webSocketRx";
import { eventBusType } from "../../config/Constant";
import { useSideBarStore } from "../../store/SideBarStore";
import { useInfoUser } from "../../store/UserStore";
import { SettingsModal } from "../modal/SettingsModal";
import "./style.scss";
import { MemberAvatar, ProfileAvatar } from "../avatar/ProfileAvatar";
import { ProfileModal } from "../modal/ProfileModal";

const REACT_APP_AUTHENTICATION_WEB =
  process.env.REACT_APP_AUTHENTICATION_WEB || "http://localhost:4005";

const FeatureList = ({ topFeatureList, bottomFeatureList }) => {
  return (
    <div className="flex flex-col bg-[#2a56b9] justify-between">
      <div className="flex flex-col items-center gap-[10px]">
        {topFeatureList.map((feature) => (
          <div key={feature?.key}>{feature?.img}</div>
        ))}
      </div>

      <div className="flex flex-col items-center gap-[10px] mb-[10px]">
        {bottomFeatureList.map((feature) => (
          <div key={feature?.key}>{feature?.img}</div>
        ))}
      </div>
    </div>
  );
};

const FaceMenu = ({
  setIsFaceMenu,
  setIsModalProfileOpen,
  setIsOpenModalSettings,
  logout,
}) => {
  const { user, languageMap } = useInfoUser();

  const infoRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (infoRef.current && !infoRef.current.contains(event.target)) {
        setIsFaceMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="profile" ref={infoRef}>
      <div className="flex bg-[#e2e3e5] p-2 w-full items-center">
        <div className="me-3">
          <div className="relative avatarWrapper inline-block ">
            <ProfileAvatar />
          </div>
        </div>
        <div>
          <div>
            <h3 className="text-base text-[#23497c] font-bold ">
              {user?.name}
            </h3>
          </div>
          <div className="mt-1">
            <h6 className="text-xs text-[#23497c] break-all">{user?.userId}</h6>
          </div>
          <div className="mt-1">
            <h6 className="text-xs text-[#23497c] break-all">{user?.email}</h6>
          </div>
          <div className="mt-1">
            <h6 className="text-xs text-[#23497c] break-all">{user?.phone}</h6>
          </div>
          <div className="mt-1">
            <h6 className="text-xs text-[#23497c] break-all">{user?.mood}</h6>
          </div>
        </div>
      </div>

      <Divider className=" mt-0" />
      <button
        className="profile-item"
        onClick={() => {
          setIsModalProfileOpen(true);
          setIsFaceMenu(false);
        }}
      >
        {languageMap?.["menu.profile.myProfile"] ?? "My Profile"}
      </button>
      <button
        className="profile-item"
        onClick={() => {
          setIsOpenModalSettings(true);
          setIsFaceMenu(false);
        }}
      >
        {languageMap?.["menu.profile.setting"] ?? "Setting"}
      </button>
      <Divider />
      <button className="profile-item" onClick={logout}>
        {languageMap?.["menu.profile.logout"] ?? "Logout"}
      </button>
    </div>
  );
};

const SideBar = () => {
  const [isOpenModalSettings, setIsOpenModalSettings] = useState(false);
  const [isModalProfileOpen, setIsModalProfileOpen] = useState(false);
  const [isFaceMenu, setIsFaceMenu] = useState(false);
  const [activeFeature, setActiveFeature] = useState("conversation");
  const [topFeatureList, setTopFeatureList] = useState([]);
  const [bottomFeatureList, setBottomFeatureList] = useState([]);

  const [isMobile, setIsMobile] = useState(false);
  const handleResize = (e) => {
    setIsMobile(e?.matches);
  };

  const navigate = useNavigate();
  const { switchIsRecord, setIsOrganizationSideBar, isOrganizationSideBar } =
    useSideBarStore((state) => state);

  const { user, updateUser, languageMap } = useInfoUser();

  const logout = async () => {
    await apiFactory.userApi.logout({
      fcmToken: Cookies.get("fcm_token"),
      token: Cookies.get("access_token"),
    });
    closeAuthSocket();
    closeChatSocket();
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    updateUser(null);
    window.location.href = REACT_APP_AUTHENTICATION_WEB + "/login?logout=true";
  };

  const closeModalSettings = () => {
    setIsOpenModalSettings(false);
  };

  const closeProfilerModal = () => {
    setIsModalProfileOpen(false);
  };

  useEffect(() => {
    setTopFeatureList([
      {
        key: "face",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["menu.profile.myProfile"] ?? "My Profile"}
            color={"#0091ff"}
          >
            <button
              className="p-[12px]"
              onClick={() => {
                setIsFaceMenu(true);
              }}
            >
              <div className="flex cursor-pointer flex items-center">
                {/*<CustomAvatar*/}
                {/*  person={user}*/}
                {/*  userId={user?.userId}*/}
                {/*  pos={-1}*/}
                {/*  styleCss={{}}*/}
                {/*  isShowUserStatus={{ status: false, isAlwaysTrue: true }}*/}
                {/*/>*/}
                <MemberAvatar person={user} isAction={false} />
              </div>
            </button>
          </Tooltip>
        ),
        navigationItem: "",
      },
      {
        key: "organization",
        img: (
          <Tooltip
            placement="right"
            title={
              languageMap?.["menu.sidebar.title.organization"] ?? "Organization"
            }
            color={"#0091ff"}
            className={activeFeature === "organization" ? "active-feature" : ""}
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                setIsOrganizationSideBar(!isOrganizationSideBar);

                const nextFeature =
                  activeFeature === "organization"
                    ? "conversation"
                    : "organization";

                setActiveFeature(nextFeature);

                if (
                  isMobile ||
                  !["conversation", "organization"].includes(nextFeature)
                ) {
                  navigate("/conversation");
                }
              }}
            >
              <RiOrganizationChart size={25} color="white" />
            </button>
          </Tooltip>
        ),
        navigationItem: "chatting list",
      },
      {
        key: "conversation",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["menu.sidebar.title.chat"] ?? "Chat"}
            color={"#0091ff"}
            className={activeFeature === "conversation" ? "active-feature" : ""}
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                setIsOrganizationSideBar(false);

                if (
                  isMobile ||
                  !["conversation", "organization"].includes(activeFeature)
                ) {
                  navigate("/conversation");
                }

                setActiveFeature("conversation");
              }}
            >
              {activeFeature === "conversation" ? (
                <IoChatbubbleEllipsesSharp size={25} color="white" />
              ) : (
                <IoChatbubbleEllipsesOutline size={25} color="white" />
              )}
            </button>
          </Tooltip>
        ),
        navigationItem: "chatting list",
      },
      {
        key: "work-management",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["event.title"] ?? "Event"}
            color={"#0091ff"}
            className={
              activeFeature === "work-management" ? "active-feature" : ""
            }
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                setIsOrganizationSideBar(false);
                if (activeFeature === "work-management") return;

                setActiveFeature("work-management");
                navigate("/work-management/dashboard");
              }}
            >
              {activeFeature === "work-management" ? (
                <BsCalendar2CheckFill size={23} color="white" />
              ) : (
                <BsCalendar2Minus size={23} color="white" />
              )}
            </button>
          </Tooltip>
        ),
        navigationItem: "event",
      },
      {
        key: "storage",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["storage"] ?? "Storage"}
            color={"#0091ff"}
            className={activeFeature === "storage" ? "active-feature" : ""}
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                if (activeFeature === "storage") return;
                navigate("/storage");
                setIsOrganizationSideBar(false);
                setActiveFeature("storage");
              }}
            >
              {activeFeature === "storage" ? (
                <FaFile size={23} color="white" />
              ) : (
                <FaRegFile size={23} color="white" />
              )}
            </button>
          </Tooltip>
        ),
        navigationItem: "event",
      },
      {
        key: "record",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["record"] ?? "Record"}
            color={"#0091ff"}
            className={activeFeature === "record" ? "active-feature" : ""}
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                switchIsRecord(true);
              }}
            >
              {activeFeature === "record" ? (
                <RiRecordCircleFill size={25} color="white" />
              ) : (
                <RiRecordCircleLine size={25} color="white" />
              )}
            </button>
          </Tooltip>
        ),
        navigationItem: "event",
      },
    ]);

    if (user?.roleCode !== "ADMIN") return;

    setBottomFeatureList([
      {
        key: "admin-setting",
        img: (
          <Tooltip
            placement="right"
            title={languageMap?.["admin-setting"] ?? "Admin setting"}
            color={"#0091ff"}
            className={
              activeFeature === "admin-setting" ? "active-feature" : ""
            }
          >
            <button
              className="p-[12px] mb-[10px] flex items-center"
              onClick={() => {
                if (activeFeature === "admin-setting") return;

                setIsOrganizationSideBar(false);
                setActiveFeature("admin-setting");
                navigate("/admin-setting/user");
              }}
            >
              {activeFeature === "admin-setting" ? (
                <IoSettingsSharp size={25} color="white" />
              ) : (
                <IoSettingsOutline size={25} color="white" />
              )}
            </button>
          </Tooltip>
        ),
        navigationItem: "event",
      },
    ]);
  }, [isMobile, user?.avatar, user?.roleCode, activeFeature]);

  useEffect(() => {
    const sub = sideBarFeatureEvent$.subscribe((event) => {
      if (event?.type === eventBusType.CONVERSATION) {
        setActiveFeature("conversation");
      }
    });

    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 930px)");
    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);

    return () => {
      mediaQuery.removeEventListener("change", handleResize);
    };
  }, []);

  return (
    <>
      <FeatureList
        topFeatureList={topFeatureList}
        bottomFeatureList={bottomFeatureList}
      />

      {isFaceMenu && (
        <FaceMenu
          setIsFaceMenu={setIsFaceMenu}
          setIsModalProfileOpen={setIsModalProfileOpen}
          setIsOpenModalSettings={setIsOpenModalSettings}
          logout={logout}
        />
      )}

      {isOpenModalSettings && (
        <SettingsModal
          open={isOpenModalSettings}
          onCancel={closeModalSettings}
        />
      )}
      {isModalProfileOpen && (
        <ProfileModal
          closeModal={closeProfilerModal}
          isModalOpen={isModalProfileOpen}
        />
      )}
    </>
  );
};

export { SideBar };
